import { UPDATE_BASKET_DETAILS_SUCCESS, ANALYTICS_CONVERSION } from '@store/basket/actions';
import { dataLayerPush } from '@utils/tracking';

import { generateAnalyticsOrder, formatDatesAndPrices, sanitizeOrderForAnalytics } from './utils';
import type { TrackingAction } from './types';

const trackingActionMap = {
  [ANALYTICS_CONVERSION]: 'orderComplete',
  [UPDATE_BASKET_DETAILS_SUCCESS]: 'basketUpdated',
};

export const reducers = (state = {}, action: TrackingAction) => {
  const { payload, type } = action;
  switch (type) {
    case ANALYTICS_CONVERSION: {
      if (payload) {
        const sanitized = formatDatesAndPrices(sanitizeOrderForAnalytics(payload));
        dataLayerPush({
          event: trackingActionMap[ANALYTICS_CONVERSION],
          data: sanitized,
          ecommerce: generateAnalyticsOrder(sanitized),
        });
      }
      return state;
    }
    default:
      return state;
  }
};
